import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
const venues = [{
  id: 1,
  name: 'DAYTIME',
  subtitle: 'Sophisticated Leisure',
  description: 'Discover refined daytime luxury. Artisanal cuisine, craft cocktails, and premium shisha served alongside curated entertainment on our immersive 190ft visual canvas.',
  hours: 'OPEN DAILY',
  image: 'https://images.unsplash.com/photo-1578736641330-3155e606cd40?q=80&w=2070&auto=format&fit=crop'
}, {
  id: 2,
  name: 'NIGHTLIFE',
  subtitle: 'Elite Entertainment',
  description: 'Where luxury meets celebrity. World-class entertainers, A-list athletes, and exclusive VIP experiences in an atmosphere that rivals the finest destinations globally.',
  hours: '11PM - 3AM',
  image: 'https://images.unsplash.com/photo-1576013551627-0cc20b96c2a7?q=80&w=2070&auto=format&fit=crop'
}, {
  id: 3,
  name: 'AFTER HOURS',
  subtitle: 'The Underground',
  description: "The city's best-kept secret. Curated soundscapes, artisanal mocktails, and intimate conversations in our exclusive late-night sanctuary reserved for connoisseurs.",
  hours: 'WEEKENDS ONLY',
  image: 'https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?q=80&w=2070&auto=format&fit=crop'
}];
export function VenueSection() {
  return <section id="venues" className="py-24 bg-[#0B1014] relative overflow-hidden" data-id="element-639">
      <div className="container mx-auto px-6" data-id="element-640">
        <div className="text-center mb-16" data-id="element-641">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-bold text-white mb-4 tracking-wide" data-id="element-642">
            THE ULTIMATE EXPERIENCE
          </motion.h2>
          <div className="w-24 h-1 bg-[#DDA247] mx-auto mb-6" data-id="element-643" />
          <motion.p initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-lg text-gray-300 tracking-wide" data-id="element-644">
            Three distinct worlds. One extraordinary destination.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-645">
          {venues.map((venue, index) => <motion.div key={venue.id} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="group relative h-[500px] overflow-hidden cursor-pointer" data-id="element-646">
              <div className="absolute inset-0 bg-black/40 group-hover:bg-black/20 transition-colors duration-500 z-10" data-id="element-647" />
              <img src={venue.image} alt={venue.name} className="absolute inset-0 w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700" data-id="element-648" />

              <div className="absolute inset-0 z-20 flex flex-col justify-end p-8" data-id="element-649">
                <h3 className="text-3xl font-bold text-white mb-1 tracking-wider" data-id="element-650">
                  {venue.name}
                </h3>
                <p className="text-[#DDA247] text-sm font-medium tracking-widest uppercase mb-3" data-id="element-651">
                  {venue.subtitle}
                </p>
                <p className="text-gray-300 text-sm leading-relaxed mb-4 transform translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500" data-id="element-652">
                  {venue.description}
                </p>
                <div className="flex items-center justify-between" data-id="element-653">
                  <span className="text-xs text-gray-400 tracking-widest font-medium" data-id="element-654">
                    {venue.hours}
                  </span>
                  <div className="flex items-center text-[#DDA247] font-medium tracking-widest text-sm uppercase group-hover:text-white transition-colors" data-id="element-655">
                    Explore <ArrowRight className="ml-2 w-4 h-4" data-id="element-656" />
                  </div>
                </div>
              </div>

              {/* Border effect */}
              <div className="absolute inset-4 border border-white/20 z-20 pointer-events-none group-hover:border-[#DDA247]/50 transition-colors duration-500" data-id="element-657" />
            </motion.div>)}
        </div>
      </div>
    </section>;
}